
<script>
export default {
  props: {
    titleAccess: {
      type: String,
      required: true
    },
    titleLevel: {
      type: String,
      required: true
    }
  },
  render(h) {
    return h(
      this.titleLevel,
      {
        attrs: {
          "aria-label": this.titleAccess,
          class: "panttitle"
        }
      },
      [
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              "class": "hidden-sm-and-up davi-curs font-red mobile-est"              
            }
          },
          this.titleAccess
        ),        
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              "class": "hidden-xs-only"
            }
          },
          this.$slots.partOne
        ),
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              class: "part-one hidden-xs-only"
            }
          },
          this.$slots.partTwo
        ),
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              class: "part-two davi-curs font-red hidden-xs-only"
            }
          },
          this.$slots.partThree
        ),
        h(
          "div",
          {
            attrs: {              
              class: "contenido-hide"
            }
          },
          this.titleAccess,
        ) 
      ]
    );
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.panttitle {
  padding-left: 40px;
  font-size: 28px;
  text-indent: -40px;
  line-height: 28px;
  font-weight: bold;
  .part-one {
    font-size: 1em;
  }
  .part-two {
    font-size: 1.5em;
    padding-right: 4px; 
  }
  .mobile-est{
    padding-left: 0;
  }
}
.contenido-hide{
  position: absolute;
  font-size: 1px;
  text-indent: -9999px;
}
@media (min-width: 600px) {
  .panttitle {
    font-size: 40px;
    line-height: 50px;
    .part-one {
      font-size: 0.8em;
    }
    .part-two {
      font-size: 1.4em;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Titleone.vue?0926e5ce